import { triggerSimpleAjax } from "../../helpers/httpHelper";
import { CREATE_COLLECTED_BILLS_SKU } from "../../helpers/constants/apiUrl";

const createSkuCollectedBills = (id, payload) => {
  return new Promise((res, rej) => {
    const url = `${CREATE_COLLECTED_BILLS_SKU}/${id}/`; // Append the id to the URL
    triggerSimpleAjax(
      url,
      'PATCH',
      payload,  // Pass the payload as the request body
      (response) => {
        res(response);
      },
      (err) => {
        rej(err);
      }
    );
  });
};

export default createSkuCollectedBills;
